/*
 * bleach
 * a minimal html sanitizer
 * cam@onswipe.com
 */

module.exports = require('./lib/bleach.js');



//////////////////
// WEBPACK FOOTER
// ./~/bleach/index.js
// module id = 29
// module chunks = 0